import React, { useState } from "react";
import { toast } from "sonner";
import { useI18n } from "../i18n";
import { submitContact } from "../api";
import { MapPin, Phone, Mail, Clock, Send } from "lucide-react";

const Contact = () => {
  const { t } = useI18n();
  const [form, setForm] = useState({ name: "", email: "", phone: "", subject: "", message: "" });
  const [sending, setSending] = useState(false);

  const onChange = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error(t.booking.missingFields);
      return;
    }
    setSending(true);
    try {
      await submitContact(form);
      toast.success(t.contact.sent);
      setForm({ name: "", email: "", phone: "", subject: "", message: "" });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Error");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20" data-testid="contact-page">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-16">
        <div className="lg:col-span-5">
          <p className="text-label text-[#FFB400]">
            <span className="line-accent" />
            {t.contact.eyebrow}
          </p>
          <h1 className="mt-4 font-heading text-5xl sm:text-6xl font-bold tracking-tighter text-white" data-testid="contact-title">
            {t.contact.title}
          </h1>
          <p className="mt-6 text-zinc-300 leading-relaxed">{t.contact.sub}</p>

          <ul className="mt-10 space-y-5 text-zinc-300">
            <li className="flex items-start gap-3"><MapPin size={20} className="text-[#FFB400] mt-1" /><span>{t.contact.address}</span></li>
            <li className="flex items-center gap-3"><Phone size={20} className="text-[#FFB400]" /><span>{t.contact.phoneLabel}</span></li>
            <li className="flex items-center gap-3"><Mail size={20} className="text-[#FFB400]" /><span>movixcarrental@gmail.com</span></li>
            <li className="flex items-center gap-3"><Clock size={20} className="text-[#FFB400]" /><span>{t.contact.hours}</span></li>
          </ul>
        </div>

        <form onSubmit={onSubmit} className="lg:col-span-7 bg-[#0d0d0d] border border-white/10 p-8 grid grid-cols-1 md:grid-cols-2 gap-5" data-testid="contact-form">
          <div>
            <label className="text-label block mb-2">{t.contact.name} *</label>
            <input className="movix-input" value={form.name} onChange={onChange("name")} data-testid="contact-name" />
          </div>
          <div>
            <label className="text-label block mb-2">{t.contact.email} *</label>
            <input type="email" className="movix-input" value={form.email} onChange={onChange("email")} data-testid="contact-email" />
          </div>
          <div>
            <label className="text-label block mb-2">{t.contact.phone}</label>
            <input className="movix-input" value={form.phone} onChange={onChange("phone")} data-testid="contact-phone" />
          </div>
          <div>
            <label className="text-label block mb-2">{t.contact.subject}</label>
            <input className="movix-input" value={form.subject} onChange={onChange("subject")} data-testid="contact-subject" />
          </div>
          <div className="md:col-span-2">
            <label className="text-label block mb-2">{t.contact.message} *</label>
            <textarea rows={5} className="movix-input" value={form.message} onChange={onChange("message")} data-testid="contact-message" />
          </div>
          <div className="md:col-span-2 flex justify-end">
            <button type="submit" disabled={sending} className="btn-primary glow-coral disabled:opacity-60" data-testid="contact-submit">
              <Send size={16} /> {sending ? t.common.sending : t.contact.send}
            </button>
          </div>
        </form>
      </div>

      <div className="mt-20 aspect-[16/7] border border-white/10 overflow-hidden" data-testid="contact-map">
        <iframe
          title="Movix Everett"
          className="w-full h-full"
          style={{ filter: "invert(0.92) hue-rotate(180deg) saturate(0.6) brightness(0.95)" }}
          src="https://www.openstreetmap.org/export/embed.html?bbox=-71.0700%2C42.4000%2C-71.0380%2C42.4180&layer=mapnik&marker=42.4084%2C-71.0537"
        />
      </div>
    </div>
  );
};

export default Contact;
